const getSymbolPrice = (symbol) => {
    if (!symbol)
        return 0;
    return parseInt(symbol.substring(3, 8));
};
export default getSymbolPrice;
